import { AppStorage } from './app-storage';

export abstract class SessionStorage implements AppStorage {

  abstract put(key: string, value: any): any;

  abstract get(key: string): any;

  abstract remove(key: string): any;

  abstract keys(): string[];

  abstract values(): any[];

  abstract entries(): { key: string; value: any }[];

  abstract clear(): void;
}
